import React from 'react';
import trust from './assets/mineko-trust-certificates.png';
import Trust from './Trust';

const TrustCertificates: React.FC = () => {
  return <Trust width={200} height={56} asset={trust} />;
};

export default TrustCertificates;
